import LemonAnimation from './AnimatedLemonDudeComponent'

export default LemonAnimation
